var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkdin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Linkdin",
    clipPath: "url(#clip0_76_104596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8 9.14612C8 8.5135 8.52962 8 9.1825 8H22.8175C23.4706 8 24 8.5135 24 9.14612V22.8541C24 23.4869 23.4706 24 22.8175 24H9.1825C8.52969 24 8 23.4869 8 22.8542V9.14612Z",
    fill: "#006699"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.8625 21.3892V14.1859H10.4682V21.3892H12.8625ZM11.6658 13.2025C12.5006 13.2025 13.0203 12.6494 13.0203 11.9581C13.0046 11.2511 12.5006 10.7134 11.6817 10.7134C10.8623 10.7134 10.3271 11.2511 10.3271 11.9581C10.3271 12.6493 10.8466 13.2025 11.6501 13.2025H11.6658ZM14.1877 21.3892H16.5818V17.367C16.5818 17.152 16.5974 16.9364 16.6606 16.7828C16.8336 16.3525 17.2276 15.9071 17.8891 15.9071C18.7553 15.9071 19.102 16.5676 19.102 17.536V21.3892H21.496V17.259C21.496 15.0466 20.315 14.017 18.7398 14.017C17.4483 14.017 16.8811 14.7388 16.566 15.2304H16.582V14.1861H14.1878C14.2191 14.8619 14.1877 21.3892 14.1877 21.3892Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_76_104596"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdin);
export default __webpack_public_path__ + "static/media/linkdin.30b9dba9ec7d4b2f2538812b89a8fa04.svg";
export { ForwardRef as ReactComponent };